(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9459],{

/***/ 12943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _elements_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _elements_Card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55877);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41197);
/* harmony import */ var _elements_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51524);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58042);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40670);
/* harmony import */ var _elements_SlickSlider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12817);
/* harmony import */ var _elements_Section__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24447);
/* harmony import */ var lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79697);
/* harmony import */ var _custom_EstateCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78032);












var Rentals = function(param) {
    var title = param.title, _properties = param.properties, properties = _properties === void 0 ? false : _properties, _intro = param.intro, intro = _intro === void 0 ? false : _intro, buttonLabel = param.buttonLabel, _buttonLink = param.buttonLink, buttonLink = _buttonLink === void 0 ? "/vacation-rentals" : _buttonLink, _target = param.target, target = _target === void 0 ? "listings" : _target, _background = param.background, background = _background === void 0 ? "primary" : _background, _bottomTitle = param.bottomTitle, bottomTitle = _bottomTitle === void 0 ? "Your direct line to exclusive<br /> villa rentals in St. Martin / St. Maarten" : _bottomTitle, _bottomDescription = param.bottomDescription, bottomDescription = _bottomDescription === void 0 ? "Thanks to our locally-based reservations team, you get access to the best properties that fit your exact needs. But it doesn't end there. When you arrive, we'll be here to greet you and ensure your experience lives up to expectations." : _bottomDescription, cardTranslation = param.cardTranslation;
    var ref = (0,_providers_ResponsiveContext__WEBPACK_IMPORTED_MODULE_5__/* .useResponsive */ .F)(), isMobile = ref.isMobile, isSmallMobile = ref.isSmallMobile;
    if ((0,lodash_es_isEmpty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(properties) || !properties) {
        return;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Section__WEBPACK_IMPORTED_MODULE_7__["default"], {
        variant: [
            "center",
            background,
            "o-hidden"
        ],
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_4__["default"], {
                variant: isMobile && [
                    "-p0"
                ],
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title)
                    }),
                    isSmallMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                        children: properties && properties.length && properties.map(function(item, index) {
                            return target === "listings" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                translations: cardTranslation
                            }, item), index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_EstateCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                translations: cardTranslation
                            }, item), "estate-card-".concat(index));
                        })
                    }) : isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_SlickSlider__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        arrows: false,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().properties),
                        pagination: intro,
                        slidesToShow: 1,
                        infinite: false,
                        variableWidth: true,
                        children: properties && properties.length && properties.map(function(item, index) {
                            return target === "listings" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                sizes: "(min-width: 1250px) 588px, (max-width: 1250px) 50vw, 50vw",
                                translations: cardTranslation
                            }, item), index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_EstateCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                translations: cardTranslation
                            }, item), "estate-card-".concat(index));
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: [
                            "grid-2"
                        ],
                        children: properties && properties.length && properties.map(function(item, index) {
                            return target === "listings" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Card__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                translations: cardTranslation,
                                sizes: "(min-width: 1250px) 588px, (max-width: 1250px) 50vw, 50vw"
                            }, item), index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_custom_EstateCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                translations: cardTranslation
                            }, item), "estate-card-".concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Container__WEBPACK_IMPORTED_MODULE_4__["default"], {
                variant: [
                    "-xs2"
                ],
                children: [
                    intro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().divider)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                dangerouslySetInnerHTML: {
                                    __html: bottomTitle
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: bottomDescription
                                },
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().description)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        href: buttonLink,
                        variant: [
                            !intro && "mt-lg",
                            "xl",
                            background !== "primary" ? "color-primary" : ""
                        ],
                        children: buttonLabel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Rentals);


/***/ }),

/***/ 58042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"styles_divider__rY_bN","title":"styles_title__qdqW4","description":"styles_description__HjLNX","properties":"styles_properties__mgx2O","cards":"styles_cards__2xng4","content":"styles_content__fhKky"};

/***/ }),

/***/ 290:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93589);
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18533);



/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    ((0,_isObjectLike_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value) && (0,_baseGetTag_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(value) == numberTag);
}

/* harmony default export */ __webpack_exports__["Z"] = (isNumber);


/***/ })

}]);